import { jsxs as t, Fragment as k, jsx as e } from "react/jsx-runtime";
import { useBreakpoint as g, SkeletonFrame as r, SkeletonType as n, Breakpoints as _ } from "@nextgen-web-framework/all";
import './assets/PageFilterSkeleton.css';const f = "#ffffff", z = "#396e75", V = "#e5fdff", C = "#546223", h = "#f0fae5", u = "#a65523", m = "#fff1e8", b = "#7f3e3e", p = "#ffe2e2", B = "#62625a", y = "#f8f8e7", v = "#38539a", O = "#707070", G = "#c8f8d1", N = "#87c9c8", R = "#5291b1", w = "rgba(82, 145, 177, 0.1019607843)", S = "#445685", T = "#181d61", W = "rgba(24, 29, 97, 0.1019607843)", P = "#5969d6", Y = "#ea999d", x = "#b6577e", A = "rgba(182, 87, 126, 0.1019607843)", F = "#7e3e80", j = "#1e247f", q = "rgba(30, 36, 127, 0.1019607843)", U = "#da7600", I = "#107f47", M = "#d91734", X = "_html_d4nek_46", $ = "_skeleton_d4nek_110", D = "_badge_d4nek_132", E = "_icon_d4nek_156", H = "_sticky_d4nek_168", a = {
  amwayWhite: f,
  darkBlue: z,
  lightBlue: V,
  darkGreen: C,
  lightGreen: h,
  darkOrange: u,
  lightOrange: m,
  darkRed: b,
  lightRed: p,
  darkYellow: B,
  lightYellow: y,
  darkPurple: v,
  darkGrayOnWhite: O,
  dataVizColor1: G,
  dataVizColor2: N,
  dataVizColor3: R,
  dataVizColor3Background: w,
  dataVizColor4: S,
  dataVizColor5: T,
  dataVizColor5Background: W,
  dataVizColor6: P,
  dataVizColor7: Y,
  dataVizColor8: x,
  dataVizColor8Background: A,
  dataVizColor9: F,
  dataVizColor10: j,
  dataVizColor10Background: q,
  dataVizAlertOrange: U,
  dataVizSuccessGreen: I,
  dataVizWarningRed: M,
  "no-visible": "_no-visible_d4nek_42",
  html: X,
  "search-page-filter": "_search-page-filter_d4nek_80",
  "no-border": "_no-border_d4nek_91",
  "sort-and-filter-btn-container": "_sort-and-filter-btn-container_d4nek_94",
  skeleton: $,
  "filter-divider": "_filter-divider_d4nek_113",
  "quick-filters": "_quick-filters_d4nek_118",
  "skeleton-tabs": "_skeleton-tabs_d4nek_121",
  badge: D,
  icon: E,
  sticky: H,
  "skeleton-loading": "_skeleton-loading_d4nek_1"
}, L = () => {
  const d = g(), i = [...Array(5)].map((o, c) => c), { XS: l, SM: s } = _;
  return /* @__PURE__ */ t("div", { "data-testid": "page-filter-skeleton", "data-pod-name": "search", className: `${a["search-page-filter"]}`, children: [
    ![l, s].includes(d) && /* @__PURE__ */ t(k, { children: [
      /* @__PURE__ */ e("div", { className: a["sort-and-filter-btn-container"], children: /* @__PURE__ */ e(r, { className: a.skeleton, type: n.BUTTON, isRoundCorner: !0 }) }),
      /* @__PURE__ */ e("div", { className: a["filter-divider"] })
    ] }),
    /* @__PURE__ */ e("div", { className: a["skeleton-tabs"], children: i.map((o) => /* @__PURE__ */ e(r, { className: a.skeleton, type: n.BUTTON, isRoundCorner: !0 }, o)) })
  ] });
};
export {
  L as P,
  a as s
};
//# sourceMappingURL=PageFilterSkeleton-5f654b1d.mjs.map
